var _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStroop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 14C64 14 78 22 82 36C86 48 80 56 84 66C86 74 78 84 66 86C56 88 54 82 42 84C30 86 18 78 16 66C14 54 22 50 20 40C18 28 28 16 42 14C46 13.6 48 14 52 14Z",
    fill: "#F9907B"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 58,
    fontFamily: "sans-serif",
    fontSize: 28,
    fontWeight: "bold",
    fill: "#C75E5A",
    textAnchor: "middle"
  }, "A")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStroop);
export default __webpack_public_path__ + "static/media/Stroop.a360eca9c804021dc10a6772f1e7e308.svg";
export { ForwardRef as ReactComponent };